



















import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {CancelBedSchedu,CancelDly} from '../../../api/dialysisProcess'



@Component({
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
   
    loading:boolean = false
    mounted() {
        
    }
    //删除排床
    async cancelBedSchedu(data:any){
        let res = await CancelBedSchedu(data)
        this.$emit('input',false);
        this.$emit('on-success')
    }
   
    actions(){
        switch(this.data.title){
            case '删除排床':
            this.cancelBedSchedu(this.data)
            break;
        }
    }

    
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/actionInfo.vue